<template>
    <div class="o-mobnav" id="mobnav">
        <div class="o-mobnav__current">
            <span class="o-mobnav__count">{{ count }}</span>
            <strong class="o-mobnav__title" v-html="module_title"></strong>
        </div>
        <preview-next format="sm"></preview-next>
    </div>
</template>

<script>
export default {
    computed: {
        count: function() {

            if( isNaN( this.$route.meta.order ) || !this.$route.meta.order ) {
                return '';
            }

            let current = this.$route.meta.order.toString(),
                total = this.highlights_data.length.toString();

            current = current.length < 2 ? '0' + current : current;
            total = total.length < 2 ? '0' + total : total;

            return current + '/' + total;
        },
        module_title: function() {
            return this.$route.meta.title || '';
        }
    }
}
</script>
